import { isNil } from 'ramda';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { Box } from '~common/components/box.component';
import { Color } from '~common/model/basics';
import { Button } from '~common/components/button/button.component';
import { PlusIcon } from '~web/view/components/ui/icon/plus.icon';

interface Props {
  media: MediaData;
  onMediaSelected?: (media: MediaData) => void;
}

export const MediaListVideoItem: React.FunctionComponent<Props> = ({ media, onMediaSelected }) => {
  const [error, setError] = useState<boolean>(undefined);
  const videoRef = useRef<HTMLVideoElement>(undefined);

  useEffect((): void => {
    if (!isNil(videoRef.current)) {
      // Improves video preview experience by showing 1 sec frame
      // some videos start with a black frame at the very beginning
      videoRef.current.currentTime = 1;
    }
  }, [videoRef.current]);

  if (error) {
    return null;
  }

  return (
    <Container>
      <Video
        ref={videoRef}
        onError={(): void => {
          setError(true);
        }}
        controls
      >
        <source src={media.url} />
      </Video>
      <PickButton
        color={Color.White}
        onClick={(): void => {
          onMediaSelected?.(media);
        }}
      >
        <PlusIcon color={Color.Black} />
      </PickButton>
    </Container>
  );
};

const Container = styled(Box)`
  height: 180px;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
  margin-bottom: 16px;

  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  overflow: hidden;
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
`;

const PickButton = styled(Button)`
  && {
    position: absolute;
    top: 4px;
    left: -18px;

    min-width: 34px;
    min-height: 34px;
    width: 34px;
    height: 34px;

    padding: 0;
    margin-left: 24px;
    margin-right: 20px;
  }
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-list/media-list-video-item.component.tsx